<div class="floating-container">
    <mat-card>
        <mat-card-header>
            <mat-card-title>{{'Pages.ItemAdded.Title' | translate}}</mat-card-title>
        </mat-card-header>
        <img mat-card-image style="max-width: 512px;" src="{{lastItem?.Picture}}" onerror="this.src='assets/img/placeholder.png'">
        <mat-card-content>
            <p>{{lastItem?.CountName}} {{'Pages.ItemAdded.ItemMessage' | translate}}</p>
          </mat-card-content>
          <mat-card-actions>
            <button mat-flat-button color="accent" class="fill-parent-width" (click)="keepBuying()">{{'Pages.ItemAdded.KeepBuyingButton' | translate}}</button>
            <div style="height:10px;"></div>
            <button mat-flat-button color="accent" (click)="finishOrder()" class="fill-parent-width">{{'Pages.ItemAdded.FinishOrderButton' | translate}}</button>
        </mat-card-actions>
    </mat-card>
</div>